import { render, staticRenderFns } from "./GroupReceiptStatus.vue?vue&type=template&id=5c89fe9a&scoped=true&"
import script from "./GroupReceiptStatus.vue?vue&type=script&lang=js&"
export * from "./GroupReceiptStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c89fe9a",
  null
  
)

export default component.exports